import {
    LOAD_WORK_ORDER_SUCCESS,
    UNLOAD_WORK_ORDER
} from "../actions/dispatchTypes";

export default function repurposeAnnouncementsReducer(state = null, action) {
    switch (action.type) {
        case LOAD_WORK_ORDER_SUCCESS:
            return action.payload.repurposeAnnouncements || state;
        case UNLOAD_WORK_ORDER:
            return null;
        default:
            return state;
    }
}
